import React from 'react'
import { useTranslation } from 'react-i18next';

import ContactForm from './ContactForm';
import { PageSection } from 'cityads-v3/components/Page';

type ContactFormPageSectionProps = {
  className?: string
}

export default function ContactFormPageSection({
  className,
  ...rest
}: ContactFormPageSectionProps): JSX.Element {
  const { t } = useTranslation(['main'])

  return (
    <PageSection
      className={className}
      title={t('writeUs')}
      rightColor="#cf0"
      rightImage={require('./img/contacter.png')}
    >
      <ContactForm
        {...rest}
      />
    </PageSection>
  )
}
